$(document).on('click', '#create_account', function () {
	if (!$(this).is(':checked')) {
		$('.create-account-container').slideUp();
		$('.create-account-container input').val('');
		$('.create-account-container input.required').removeAttr('required');
	} else {
		$('.create-account-container').slideDown();
		$('.create-account-container input.required').attr('required', 'required');
	}
});

$(document).on('click', '#upload_file_switch', function () {
	$('#upload_file_fields').slideToggle();
});

$(document).on('click', '.change-selection', function (e) {
	e.preventDefault();

	$('html, body').animate({
		scrollTop: $('#searchbar_footer_container').offset().top - ($('header').outerHeight() + 40)
	}, 0);
});

$(document).on('click', '.landingpage-light a', function (e) {
	e.preventDefault();
	$('#lastname').focus();
});

var inputFileCount = 1;
$(document).on('change', '.input-file input[type="file"]', function () {
	if ($(this).val() !== '') {
		$('.input-file').eq(inputFileCount++).slideDown();

		if ($('#content').val() === '') {
			$('#content').val('Zie bijlage');
		}
	}
});

$(document).ready(function () {
	if ($('#upload_file_switch').prop('checked') == true) {
		$('.input-file').eq(1).slideDown();
	}

	// setBlurredBackgroundPosition();
});
$(window).resize(function () {
	// setBlurredBackgroundPosition();
});

var $blurredBackground = $('.blurred-background');
var $main = $blurredBackground.parent();

function setBlurredBackgroundPosition() {
    return;
	var mainPosition = $main.position();
	var correction = Math.ceil($(window).width() - (mainPosition.left + $main.outerWidth()));

	if (!$blurredBackground.hasClass('blurred')) {
		$blurredBackground.css({
			background: 'url(/images/header.jpg) no-repeat',
			backgroundPosition: 'right -' + correction + 'px top -61px',
			filter: 'blur(3px)'
		});
		$blurredBackground.addClass('blurred')
	} else {
		$blurredBackground.css({
			backgroundPosition: 'right -' + correction + 'px top -61px'
		});
	}
}
$(document).ready(function () {
	$(document).on('click', '#start_search', function (e) {
		e.preventDefault();

		$('html, body').animate({
			// @if ($hasSelectedPapers)
			// scrollTop: $(".home.page .search-bar--white").offset().top - 80
			// @else
			scrollTop: $(".home.page .search-bar--white").offset().top - ($(window).height() / 2) + 100
			// @endif
		}, 1000);

		$('.search-input--body').first().focus();
	});
});

inputFileCount = 1;
$(document).on('change', '.input-file input[type="file"]', function () {
	if ($(this).val() !== '') {
		$('.input-file').eq(inputFileCount++).slideDown();
	}
});
